import { useState } from "react";
import { Alert, Col, Nav, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../store";
import AuditLogs from "./AuditLogs";
import Listings from "./Listings";

type EntitiesView = "audit" | "listings";

function Entities() {
  const activeCompany = useAppSelector((state) => state.company.activeCompany);
  const [view, setView] = useState<EntitiesView>("audit");
  const [auditPrefilter, setAuditPrefilter] = useState<{ entityType?: string; entityId?: string }>({});

  const handleViewAudit = (entityType: string, entityId: string) => {
    setAuditPrefilter({ entityType, entityId });
    setView("audit");
  };

  if (!activeCompany) {
    return (
      <div>
        <h3 className="mb-4">Entities</h3>
        <hr className="mb-4" />
        <p className="text-muted">
          Select a company on the <Link to="/companies">Companies</Link> page to view its data.
        </p>
      </div>
    );
  }

  return (
    <div>
      <h3 className="mb-4">Entities</h3>
      <hr className="mb-4" />
      <Row>
        <Col md={2} className="mb-3">
          <Nav variant="pills" className="flex-column">
            <Nav.Link active={view === "audit"} onClick={() => setView("audit")}>
              Audit Logs
            </Nav.Link>
            <Nav.Link active={view === "listings"} onClick={() => setView("listings")}>
              Listings
            </Nav.Link>
          </Nav>
          <Alert variant="warning" className="mt-3 py-2 px-3 small mb-0">
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            This only visualises Windmill data. Automations are not yet based on Windmill data.
          </Alert>
        </Col>
        <Col md={10}>
          {view === "audit" ? (
            <AuditLogs
              key={`${auditPrefilter.entityType ?? ""}-${auditPrefilter.entityId ?? ""}`}
              companyNameOrId={activeCompany.name}
              initialEntityType={auditPrefilter.entityType}
              initialEntityId={auditPrefilter.entityId}
            />
          ) : (
            <Listings companyNameOrId={activeCompany.name} onViewAudit={handleViewAudit} />
          )}
        </Col>
      </Row>
    </div>
  );
}

export default Entities;
